import ContentPage from '../../content/ContentPage';
import { track } from '../../track/utils';
import React, { useCallback } from 'react';
import { Accommodation, Page } from '../../resources/modelTypes';

export type TravelProps = {
  accommodations: Accommodation[],
  configuration: {
    imageAlignment: string,
    imageSize: number,
    pageLayout: string,
    showMap: boolean,
    textAlignment: string,
  },
  id: string,
  pageData: Page,
  title: string,
}

const Travel = ({
  accommodations, configuration, id, pageData, title,
}: TravelProps) => {
  const actionLinkHandler = useCallback(
    () => track('View Travel & Accommodations', 'Travel_Visit_URL_clicked'),
    [],
  );

  return (
    <ContentPage
      actionLinkProps={
        {
          onClick: actionLinkHandler,
          text: 'Visit Website',
        }
      }
      configuration={configuration}
      data={accommodations}
      id={id}
      pageData={pageData}
      title={title}
    />
  );
};

export default Travel;
